import { Sun } from 'lucide-react';
import SpotCounter from './SpotCounter';
import TrustBadges from './TrustBadges';
import SocialProof from './SocialProof';
import PremiumCTA from './PremiumCTA';
import { pushToDataLayer } from '../utils/gtm';

export default function Closing() {

  return (
    <section className="relative py-20 lg:py-32 bg-gradient-to-b from-white to-green-50 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 right-10 w-64 h-64 bg-green-200 rounded-full opacity-20 blur-3xl" />
        <div className="absolute bottom-20 left-10 w-96 h-96 bg-amber-200 rounded-full opacity-20 blur-3xl" />
      </div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Sunrise Visual */}
        <div className="flex justify-center mb-12">
          <div className="relative">
            <div className="w-32 h-32 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full flex items-center justify-center shadow-2xl">
              <Sun className="w-16 h-16 text-white" />
            </div>
            <div className="absolute inset-0 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full animate-ping opacity-20" />
          </div>
        </div>

        {/* Main Quote */}
        <div className="text-center space-y-8 mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight max-w-3xl mx-auto">
            „In einer Woche wirst du auf die Waage steigen – und dich fragen, warum du das nicht
            früher gemacht hast."
          </h2>

          <p className="text-xl text-gray-700 max-w-2xl mx-auto">
            Der erste Schritt ist der wichtigste. Und er ist leichter, als du denkst.
          </p>
        </div>

        {/* Countdown */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 lg:p-12 mb-8 space-y-6">
          <SpotCounter variant="default" showProgressBar={true} />
          <p className="text-center text-lg text-gray-700 mb-2 font-medium">
            Nur 100 Plätze verfügbar – danach kostet das Programm 149 €.
          </p>
          <p className="text-center text-base text-gray-600 mb-6">
            Aktionspreis endet, sobald 100 Plätze vergeben sind.
          </p>


          {/* Final CTA */}
          <PremiumCTA
            href="https://www.digistore24.com/product/642539/siebentage5kilo/?ds24_domain=www.digistore24.com&voucher=7TageStart"
            variant="gradient"
            size="lg"
            fullWidth
            onClick={() => pushToDataLayer('initiate_checkout')}
          >
            Aktionspreis sichern – solange Plätze frei sind
          </PremiumCTA>

          <div className="mt-6 text-center space-y-2">
            <p className="text-gray-900 text-lg">
              Heute:{' '}<span className="font-bold text-2xl text-orange-600">49 €</span>{' '}
              <span className="line-through text-gray-500">149 €</span>
            </p>
            <p className="text-gray-600">
              Nur die ersten 100 erhalten den Aktionspreis.
            </p>
          </div>

          <SocialProof variant="combined" showAnimation={true} />
        </div>

        {/* Trust Badges */}
        <TrustBadges variant="default" showLabels={true} />
      </div>
    </section>
  );
}
